

































import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';

import { store } from '../store/edit';

export default PageModeMixin.extend({
	name: 'Poznamka',
	props: {
		storeUri: String,
		zapujckaStav: Object,
	},
	computed: {
		...genVuexComputeds(store),
		nakladyJdnLabelKey(): string {
			if (this.VozidlopaId) {
				return 'NakladyVoz';
			}
			if (this.OstatnipaId) {
				return 'PorizNakl';
			}
			return 'NAKLADY_JDN';
		},
		isPoznamkaDisabled(): boolean {
			return this.zapujckaStav.isFakturovana || this.isViewMode;
		},
	},
});
